/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Root reducer map — combines all feature slice reducers.
 *
 * When adding a new feature slice, import its reducer and add it to the
 * RootReducer object. The key MUST match the slice `name` field so that
 * `state.{feature}` resolves correctly.
 */

// Feature slice reducers — import and register new slices here
import { alertOverlayReducer } from "./alertOverlay";
import { appStartupReducer } from "./appStartup";
import { appVersionOverrideReducer } from "./appVersionOverride";
import { appVisibilityReducer } from "./appVisibility";
import { brandingReducer } from "./branding";
import { channelChangeReducer } from "./channelChange";
import { channelNumberEntryReducer } from "./channelNumberEntry";
import { contentDetailReducer } from "./contentDetail";
import { featureOverrideReducer } from "./featureOverride";
import { guideReducer } from "./guide";
import { homescreenReducer } from "./homescreen";
import { myHubReducer } from "./myHub";
import { profilesReducer } from "./profiles";
import { recordingHighlightReducer } from "./myHub/recordingHighlight";
import { postSigninStartupReducer } from "./postSigninStartup";
import { networkAvailabilityReducer } from "./networkAvailability";
import { osdReducer } from "./osd";
import { screensReducer } from "./screens";
import { searchReducer } from "./search";
import { seeMoreReducer } from "./seeMore";
import { seriesRecordingOptionsReducer } from "./myHub/seriesRecordingOptions";
import { showsAndMoviesReducer } from "./showsAndMovies";
import { signInReducer } from "./signIn";
import { mobileLandingDialogReducer } from "./mobileLandingDialog";
import { toastMessageReducer } from "./toastMessage";
import { unityDialogReducer } from "./unityDialog";
import { videoDebugOverlayReducer } from "./videoDebugOverlay";
import { videoPlayerUiReducer } from "./videoPlayerUi";
import { playerCarouselReducer } from "./playerCarousel";
import { recordingsStatusReducer } from "./recordingsStatus";

const RootReducer = {
  alertOverlay: alertOverlayReducer,
  appStartup: appStartupReducer,
  appVersionOverride: appVersionOverrideReducer,
  appVisibility: appVisibilityReducer,
  branding: brandingReducer,
  channelChange: channelChangeReducer,
  channelNumberEntry: channelNumberEntryReducer,
  contentDetail: contentDetailReducer,
  featureOverride: featureOverrideReducer,
  guide: guideReducer,
  homescreen: homescreenReducer,
  mobileLandingDialog: mobileLandingDialogReducer,
  myHub: myHubReducer,
  profiles: profilesReducer,
  recordingHighlight: recordingHighlightReducer,
  playerCarousel: playerCarouselReducer,
  postSigninStartup: postSigninStartupReducer,
  recordingsStatus: recordingsStatusReducer,
  networkAvailability: networkAvailabilityReducer,
  osd: osdReducer,
  screens: screensReducer,
  search: searchReducer,
  seeMore: seeMoreReducer,
  seriesRecordingOptions: seriesRecordingOptionsReducer,
  showsAndMovies: showsAndMoviesReducer,
  signIn: signInReducer,
  toastMessage: toastMessageReducer,
  unityDialog: unityDialogReducer,
  videoDebugOverlay: videoDebugOverlayReducer,
  videoPlayerUi: videoPlayerUiReducer
};

export default RootReducer;
